import { PageSlugs } from "../../../add-element/types";
import { IsPreviewOrDemoProvider } from "../../../contexts/IsPreviewOrDemoContext";
import { withInvalidRouteRedirect } from "../../../core/routing";
import {
  getAllResources,
  getResource,
  filterPage,
  selectSite,
} from "../../selectors";
import FancyClothesProvider from "../FancyClothesProvider";
import Footer from "../Footer";
import WebsiteHeader from "../WebsiteHeader";
import WebsitePages from "../WebsitePages";
import OnlineInvitationRSVPButton from "./OnlineInvitationRSVPButton";
import { css, Global } from "@emotion/react";
import {
  GlobalStyles,
  theme,
  useMediaQueryState,
} from "@minted/minted-components";
import React from "react";
import { connect } from "react-redux";

const stickyButtonPadding = css`
  margin-bottom: ${theme.spacing.x8};
`;

const OnlineInvitationSite = ({
  event,
  pages,
  resources,
  site,
  themeAuthor,
}) => {
  const mediumMediaQueryState = useMediaQueryState({
    mediaQuerySize: "medium",
  });

  const isMobile = mediumMediaQueryState === "BELOW";
  const filteredPages = pages.filter((page) =>
    filterPage(page, {
      ...resources,
      sites: [site],
    }),
  );

  const customCssElement = site.extraCss ? (
    <Global
      styles={css`
        ${site.extraCss}
      `}
    />
  ) : null;

  return (
    <FancyClothesProvider>
      <GlobalStyles />
      {customCssElement}
      <IsPreviewOrDemoProvider
        isDemo={Boolean(site.isDemoSite)}
        isPreview={false}
      >
        <div id="home">
          <WebsiteHeader condensed={false} pages={filteredPages} />
        </div>
        <WebsitePages
          pages={filteredPages}
          resources={resources}
          site={site}
          source="website"
        />
        <OnlineInvitationRSVPButton event={event} site={site} />
        <Footer artist={themeAuthor} />
        {isMobile && <div css={stickyButtonPadding} />}
      </IsPreviewOrDemoProvider>
    </FancyClothesProvider>
  );
};
const mapStateToProps = (state) => {
  const site = selectSite(state.resources.sites);

  const pages = getResource(state.resources.pages);
  const events = getResource(state.resources.events);
  const resources = getAllResources(state.resources);

  return {
    event: events[0],
    pages,
    resources,
    site,
    themeAuthor: state.theme.attribution,
  };
};

// Apply Redux connection and route redirect handling
export default withInvalidRouteRedirect(
  connect(mapStateToProps)(OnlineInvitationSite),
  {
    redirectTo: PageSlugs.Root,
  },
);
